export interface NotificationItem {
  id: number;
  label: string;
  value: number;
  checked: boolean;
}

export interface Email {
  id: string;
  address: string;
}

export interface PercentageOption {
  id: string;
  label: string;
}

// Contract Length Component Mock Data
export const defaultContractLength = 12;
export const defaultAutoRenew = true;

// Renewal Notifications Component Mock Data
export const defaultRenewalNotifications: NotificationItem[] = [
  { id: 1, label: "1st Notification", value: 90, checked: true },
  { id: 2, label: "2nd Notification", value: 30, checked: true },
  { id: 3, label: "3rd Notification", value: 7, checked: true },
];

// Consumption Notifications Component Mock Data
export const defaultIsOverSubscriptionEnabled = true;
export const defaultIsOverProspectEnabled = true;
export const defaultSelectedPercentages = ["10%", "20%", "80%"];
export const percentageOptions: PercentageOption[] = [
  { id: "10", label: "10%" },
  { id: "20", label: "20%" },
  { id: "80", label: "80%" }
];

// Send Notifications Component Mock Data
export const defaultEmails: Email[] = [
  { id: "1", address: "robin.smit@portland.com" },
  { id: "2", address: "lili.smit@portland.com" },
];

// Form Values Interface
export interface ContractSettingsFormValues {
  contractLength: number;
  autoRenew: boolean;
  renewalNotifications: NotificationItem[];
  isOverSubscriptionEnabled: boolean;
  isOverProspectEnabled: boolean;
  selectedPercentages: string[];
  emails: Email[];
}

// Initial Form Values
export const getContractSettingsInitialValues = (): ContractSettingsFormValues => ({
  contractLength: defaultContractLength,
  autoRenew: defaultAutoRenew,
  renewalNotifications: defaultRenewalNotifications,
  isOverSubscriptionEnabled: defaultIsOverSubscriptionEnabled,
  isOverProspectEnabled: defaultIsOverProspectEnabled,
  selectedPercentages: defaultSelectedPercentages,
  emails: defaultEmails,
});

